import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_ONBOARDING_SCHEMA = Object.freeze({
  NEW_USER: false,
  ACCOUNT_TEMPLATE_TYPE: '',
  ACCOUNT_OWNER: '',
});
const RECORD = generateSchema(TRACKING_ONBOARDING_SCHEMA);
const KEYS: any = generateKeys(TRACKING_ONBOARDING_SCHEMA);

export class OnboardingTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.onboarding;
  }

  get properties() {
    return this.toJS();
  }
}
